/**
 * Konstanta penyimpanan lokal Mode Kasir Zero-Loading (port dari kledopos-mobile
 * `services/localdb/schema.ts`). Penyimpanan memakai IndexedDB (lewat `idb`).
 */

export const DB_NAME = 'kledo-pos-catalog'

/**
 * Versi IndexedDB (struktur object store). Naikkan bila menambah store/index.
 * Beda dari CATALOG_SCHEMA_VERSION: itu versi MAPPING data katalog.
 */
export const DB_VERSION = 1

/**
 * Versi mapping data katalog. Bila berubah → katalog di-clear & full-resync
 * (antrean transaksi `async_ops` TIDAK ikut di-clear).
 */
export const CATALOG_SCHEMA_VERSION = 1

export const STORES = {
  META: 'meta',
  PRODUCTS: 'products',
  PRICE_RULES: 'price_rules',
  ASYNC_OPS: 'async_ops',
  LOCAL_SEQ: 'local_seq',
}

/** Status op di antrean async (lokal). */
export const OP_STATUS = {
  PENDING: 0,
  SENT: 1,
  DONE: 2,
  FAILED: 3,
  /** Dibuang di BE (status_id 6) — final, tidak memblokir tutup shift. */
  DISCARDED: 4,
  /** Terblokir di BE (status_id 5) — menunggu transaksi lain; diselesaikan via /resolve. */
  BLOCKED: 5,
}

/** Kunci-kunci di store meta. */
export const META_KEYS = {
  schemaVersion: 'schema_version',
  /** Endpoint tenant tempat katalog di-scope — untuk deteksi ganti perusahaan. */
  scopeEndpoint: 'scope_endpoint',
  /** Cursor delta produk (unix detik) dari `synced_at` respons /pos/products/changed. */
  productsSyncedAt: 'products_synced_at',
  /** Timestamp sukses sync terakhir (ms). */
  lastSyncedAt: 'last_synced_at',
}

/** Jenis transaksi di kontrak /pos/asyncOperations. */
export const TRANS_TYPE = {
  INVOICE: 5,
  ORDER: 6,
}
